import { Action, ThunkAction, combineReducers, configureStore, createAction } from "@reduxjs/toolkit"

import { mblsconnectorApi } from "src/features/mblsConnector/mblsConenctorApi"
import { reportApi } from "src/features/report/reportApi"
import { thingsApi } from "src/features/things/thingsApi"
import { reservationSyncApi } from "src/features/things/reservationSyncApi"
import { sl1ImportApi } from "src/features/things/sl1ImportApi"
import { monthlyExtractApi } from "src/features/things/monthlyExtractApi"
import { thingsSaApi } from "src/features/things/thingsSaApi"
import thingsReducer from "src/features/things/thingsSlice"
import { meApi } from "../features/me/meApi"
import meReducer from "../features/me/meSlice"
import { partnersApi } from "../features/partners/partnersApi"
import sstThingsReducer from "../features/partners/sstThingsSlice"
import { sstv2TraceApi } from "../features/sstv2-trace/sstv2TraceApi"
import { sstv2EvidenceApi } from "../features/sstv2-evidence/sstv2EvidenceApi"
import { saLockerRepairApi } from "../features/sa-locker-repair/saLockerRepairApi"
import reportReducer from "../features/report/reportSlice"
import inAppMessagesReducer from "../features/inAppMessages/inAppMessagesSlice"

export const resetStore = createAction("RESET_STORE")

const appReducer = combineReducers({
  me: meReducer,
  [meApi.reducerPath]: meApi.reducer,
  things: thingsReducer,
  [thingsApi.reducerPath]: thingsApi.reducer,
  [thingsSaApi.reducerPath]: thingsSaApi.reducer,
  [reservationSyncApi.reducerPath]: reservationSyncApi.reducer,
  [sl1ImportApi.reducerPath]: sl1ImportApi.reducer,
  [monthlyExtractApi.reducerPath]: monthlyExtractApi.reducer,
  [partnersApi.reducerPath]: partnersApi.reducer,
  [sstv2TraceApi.reducerPath]: sstv2TraceApi.reducer,
  [sstv2EvidenceApi.reducerPath]: sstv2EvidenceApi.reducer,
  [saLockerRepairApi.reducerPath]: saLockerRepairApi.reducer,
  sstThings: sstThingsReducer,
  [mblsconnectorApi.reducerPath]: mblsconnectorApi.reducer,
  report: reportReducer,
  [reportApi.reducerPath]: reportApi.reducer,
  inAppMessages: inAppMessagesReducer,
})

const rootReducer: typeof appReducer = (state, action) => {
  if (resetStore.match(action)) {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      meApi.middleware,
      thingsApi.middleware,
      thingsSaApi.middleware,
      reservationSyncApi.middleware,
      sl1ImportApi.middleware,
      monthlyExtractApi.middleware,
      partnersApi.middleware,
      sstv2TraceApi.middleware,
      sstv2EvidenceApi.middleware,
      saLockerRepairApi.middleware,
      mblsconnectorApi.middleware,
      reportApi.middleware,
    ),
})

// Agentic-mode test seam: Playwright specs can introspect / dispatch
// against the live store via `window.__store`. Gated on VITE_AGENTIC so
// production builds NEVER expose it (the env var is unset in prod).
if (typeof window !== "undefined" && import.meta.env.VITE_AGENTIC === "true") {
  ;(window as any).__store = store
}

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
